import React from 'react';
import Button from 'components/Button';
import styles from './ChatQuickReplies.module.scss';

export interface ChatQuickRepliesProps {
  questions: string[];
  disabled: boolean;
  onQuickReply: (question: string) => void;
}

const ChatQuickReplies: React.FC<ChatQuickRepliesProps> = ({
  questions,
  disabled,
  onQuickReply,
}) => {
  return (
    <div className={styles.wrapper} aria-label="Suggested questions">
      {questions.map((q) => (
        <Button
          key={q}
          type="button"
          variant="outline"
          size="sm"
          className={styles.chip}
          disabled={disabled}
          onClick={() => onQuickReply(q)}
          aria-label={`Quick reply: ${q}`}
        >
          {q}
        </Button>
      ))}
    </div>
  );
};

export default ChatQuickReplies;
